import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import * as S from './styled'
export function ErrorMessageToken() {
  const history = useHistory()
  const { t } = useTranslation()

  return (
    <S.Wrapper container>
      <S.FullGrid item xs={12}>
        <S.DescriptionBox item sm={12}>
          <S.DescriptionText>
            {t('authPages:tokenReset')}
            <br />
          </S.DescriptionText>
        </S.DescriptionBox>
        <S.GoBackLoginButton
          variant="secondary"
          onClick={() => history.push('/login')}
        >
          {t('authPages:backToLogin')}
        </S.GoBackLoginButton>
      </S.FullGrid>
    </S.Wrapper>
  )
}
